import AboutSubPage from "@/pages/about/components/AboutSubPage";

export default function CoreValuesEsPage() {
  return (
    <AboutSubPage
      heroImageSrc="https://net-basis.net/Bilder/netbasis-core-values-trust-partnership.webp"
      texts={{
        title: "Valores fundamentales",
        heroClaimLine1: "Con valores",
        heroClaimLine2: "¡al éxito!",
        bottomClaim: "NetBasis International - drive to excellence with excellent drivers !",
      }}
      metaTitle="Nuestros Valores Fundamentales | NetBasis International"
      metaDescription="Respeto, lealtad, profesionalidad, perseverancia y confianza: los pilares fundamentales para el éxito sostenible de nuestros fabricantes socios."
      metaOgUrl="https://net-basis.net/es/sobre-nosotros/valores-fundamentales"
    >
      <div className="space-y-4 text-foreground-950 leading-relaxed text-sm md:text-base">
        <h1 className="font-semibold text-foreground-950 text-sm md:text-base">
          Respeto. Lealtad. Profesionalidad. Perseverancia. Confianza.
        </h1>
        <p>Estos son los valores fundamentales sobre los que NetBasis International se apoya firmemente y que nos guían en nuestro trabajo diario. Nos acompañan en nuestra dedicación inquebrantable hacia nuestros socios comerciales y dictan la manera precisa en que cumplimos con nuestras responsabilidades operativas.</p>
        <p>Es nuestro compromiso diario con nosotros mismos demostrar de forma sostenible a los nuevos socios que han tomado la elección absolutamente correcta a nuestro lado, y asegurar a nuestros socios existentes, en el marco de proyectos conjuntos, una y otra vez que están en las mejores manos y perfectamente respaldados.</p>
        <p>Su éxito es nuestra obligación.</p>
      </div>
    </AboutSubPage>
  );
}